const BASE_MS = 2_000;
const CAP_MS = 5 * 60_000;

/**
 * Exponential backoff with full jitter (research R5): each wait is drawn
 * uniformly below a ceiling that doubles from 2 s up to 5 minutes, so tabs
 * retrying after one outage don't all arrive together.
 */
export class Backoff {
  private attempt = 0;

  constructor(private readonly random: () => number = Math.random) {}

  /** The next wait in ms; each call raises the ceiling. */
  next(): number {
    const ceiling = Math.min(CAP_MS, BASE_MS * 2 ** this.attempt);
    this.attempt += 1;
    return Math.floor(this.random() * ceiling);
  }

  reset(): void {
    this.attempt = 0;
  }
}
